<div class="mona-mic-button" [class.mona-mic-button--pulsing]="isPulsing" (click)="clicked.emit()" matRipple>
    <mat-icon class="mona-mic-button__icon">mic</mat-icon>
</div>
